export default __webpack_public_path__ + "assets/fonts/ClanPro-CompBold.41a1cff2d2c8ee0082268dc50ae7c451.otf";